// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * Claves legacy del backend (solo para adaptador de respuesta API).
 * El resto del frontend usa exclusivamente limits.{ users, messages, invitations, storage }
 * y usage.{ users, messages, invitations, storage, devices_active }.
 * NO usar estas constantes en componentes ni pantallas.
 * @file frontend/src/utils/planLegacyKeys.js
 */

export const LEGACY_LIMITS = {
  users: 'max_users',
  messages: 'max_messages_day',
  invitations: 'max_invitations_per_day',
  storage: 'max_storage_mb',
  devices_per_user: 'max_devices_per_user',
};

export const LEGACY_USAGE = {
  messages: 'messages_today',
  invitations: 'invitations_today',
  storage: 'storage_mb',
};

/** Clave legacy para almacenamiento en objeto tenant (admin API). */
export const LEGACY_TENANT_STORAGE = 'storage_mb';
